/*
 * @Description: 用户管理
 * @Author: wangwangwang
 * @Date: 2020-06-30 14:18:14
 * @LastEditors: wangwangwang
 * @LastEditTime: 2020-07-01 15:14:12
 */ 
import request from '@/utils/request'

// 获取用户数据
export function getInfo(params) {
  return request({
    url: '/base/system/index/page/get_info',
    method: 'get',
   params
  })
}
// 新增、编辑用户
export function saveOrUpdate(data) {
  return request({
    url: '/base/system/index/page/save_or_update',
    method: 'post',
   data
  })
}



